import { FC } from 'react';

import { Popup } from '@silverfort/sf-components';

import ExplainabilityContent from './ExplainabilityContent';
import ExplainabilityFooter from './ExplainabilityFooter';
import useGetThreatReason from '../../../../api/queries/useGetThreatReason';
import { PopupProps } from '../ExplainabilityProps';

const ExplainabilityPopup: FC<PopupProps> = ({ popupTitle, guid, ruleName, entityName, isOpen, onClose }) => {
    const { isFetching, data } = useGetThreatReason({
        entityGuid: guid,
        entityName,
        riskRule: ruleName,
        shouldFetch: isOpen
    });

    return (
        <Popup
            className="z-[11000]"
            open={isOpen}
            title={popupTitle}
            ContentComponent={ExplainabilityContent}
            ContentComponentProps={{
                loading: isFetching,
                reason: data?.reason
            }}
            FooterComponent={ExplainabilityFooter}
            FooterComponentProps={{
                onClose
            }}
            onClose={onClose}
            popupClassName="w-[680px] h-fit max-w-full font-sf"
            contentClassName="relative w-full h-full"
        />
    );
};

export default ExplainabilityPopup;
